// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import axios from './axios'
import router from './router'
import VueLazyload from 'vue-lazyload'
import VScrollLock from 'v-scroll-lock'
import scss from './sass/_import.scss'
import KmsFooter from './components/layout/Footer.vue'
import Toolbar from './components/layout/Toolbar.vue'
import Alert from './components/layout/StickyAlert.vue'
import KmsA from '@/components/elements/KmsA.vue'
import {merge} from 'lodash-es'
import EventBus from '@/config/eventBus.js'

//Creating EventBus for GTM
window.coma = {'EventBus': EventBus};

Vue.component('kms-a', KmsA);

Vue.config.productionTip = false

Vue.use(VueLazyload)
Vue.use(VScrollLock)

Vue.prototype.$event = new Vue()
Vue.prototype.$baseUrl = process.env.BASE_URL || ''
Vue.prototype.$http = axios
Vue.prototype.$cookie = false;

Vue.mixin({
  methods: {
    routePush: function (to, options) {
      //analytics event
      if (options.item != 'a' && options.item != 'button') {
        this.$event.$emit('userinteraction', Object.assign(options, {from: this.$route.path, to: to}));
      }

      if (typeof to == 'string' && to.startsWith("http")) {
        window.open(to, '_blank')
      } else if (typeof to == 'string' && to.startsWith("#")) {
        this.$event.$emit('move2anchor', to);
      } else if (typeof to == 'string' && to.startsWith("mailto")) {
        window.open(to, '_blank')
      } else if (typeof to == 'string' && to.startsWith("tel")) {
        window.open(to, '_blank')
      } else {
        this.$router.push(to);
      }
    }
  }
});

new Vue({
  el: '#app',
  router,
  components: {KmsFooter, Toolbar, Alert},
  methods: {
    userinteraction: function (uiElement) {
      if (window.consent.hasConsent('statistics') && typeof dataLayer !== 'undefined') {
        dataLayer.push(merge(uiElement, {event: 'userinteraction'}));
      }
    },
    pageview: function (route) {
      if (window.consent.hasConsent('statistics') && typeof dataLayer !== 'undefined') {
        dataLayer.push(merge(route, {event: 'pageview'}));
      }
    },
    blur: function (e) {
      if (e) this.$el.classList.add('blur');
      else this.$el.classList.remove('blur');
    },
    close: function () {
      this.$event.$emit('close', false);
    },
    scrollTo: function (hashtag, scrollDuration) {
      var vm = this;
      if (hashtag.charAt(0) == '#') hashtag = hashtag.substr(1);
      if (!scrollDuration) var scrollDuration = 500;

      document.querySelector('html').style.scrollBehavior = "smooth";

      setTimeout(function () {
        window.scrollTo(scrollDuration, document.getElementById(hashtag) ? document.getElementById(hashtag).offsetTop : 0);
      }, 100);

      setTimeout(function () {
        document.querySelector('html').style.scrollBehavior = "";
      }, 1000);
    }
  },
  mounted: function () {
    var vm = this;
    //this is for disable the default go back scroll bug with modern browser
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }
    vm.$event.$on('blur', this.blur);
    vm.$event.$on('move2anchor', this.scrollTo);

    vm.$event.$on('userinteraction', this.userinteraction);
    vm.$event.$on('pageview', this.pageview);

    document.getElementById("app").addEventListener("click", function (e) {
      var parent = e.path ? e.path.find(function (i) {
        return i.nodeName == "A"
      }) : null;
      if ((e.target && e.target.nodeName == "A") || parent) {
        vm.$event.$emit('userinteraction', {
          item: 'a',
          label: e.target.innerText,
          from: vm.$route.path,
          to: e.target.pathname
        });
      }
      if (e.target && e.target.nodeName == "BUTTON") {
        vm.$event.$emit('userinteraction', {
          item: 'a',
          label: e.target.innerText,
          from: vm.$route.path,
          to: e.target.getAttribute('data-to')
        });
      }
    });

  }
})



// WEBPACK FOOTER //
// ./src/main.js